import { useTranslation } from 'react-i18next';

import type { ForwardStatus } from '@nucleus-commerce/api-client/admin';

import { forwardReason } from '../schemas/forwarding';

/** Readable reason of a skip or a failure, or null when there is none to show. */
export function useForwardReasonText() {
  const { t } = useTranslation('analytics');
  return (forward: ForwardStatus): string | null => {
    const reason = forwardReason(forward);
    switch (reason.kind) {
      case 'consent':
        return t('forward.reason.consent');
      case 'unsupported':
        return t('forward.reason.unsupported');
      case 'error':
        return reason.excerpt;
      case 'none':
        return null;
    }
  };
}
